import type ValueIDMap from '@/Models/ValueIDMap';

export enum TextBlockInsertable {
    AllProcedures = 0,
    SpecificModalities,
    SpecificProcedures,
}

interface TextBlockModel {
    ID: number;
    Name: string;
    Pronunciation: string;
    Content: string;
    UseInReporting: boolean;
    UseInG2Speech: boolean;
    AutoInsert: boolean;
    LastModificationDateTime: string;
    ModifiedByName: string;
    SelectedRadiologists: number[];
    AvailableRadiologists: RadiologistModel[];
    SearchTerm: string;
    Language: string;
    ApplicableFor: number;
    Procedures: ValueIDMap[];
    Modalities: ValueIDMap[];
}

interface RadiologistModel {
    ID: number;
    FullName: string;
}

export default TextBlockModel;
